export default "__VITE_ASSET__ac9c56f4__"